// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import App from '../src/main-component/App/App';
// import reportWebVitals from './reportWebVitals';
// import GlobalAOSProvider from './GlobalAOSProvider/GlobalAOSProvider ';
// import '../node_modules/react-modal-video/scss/modal-video.scss';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import './css/fontawesome.css';
// import './css/themify-icons.css';
// import './css/animate.min.css';
// import './css/cursor.css';
// import './css/style.css';
// import './css/wallet.css';
// import { ThirdwebProvider } from "@thirdweb-dev/react";

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//     <GlobalAOSProvider>
//         <ThirdwebProvider activeChain="ethereum" clientId="00000000000000000000000000000000">
//             <App />
//         </ThirdwebProvider>
//     </GlobalAOSProvider>
// );

// reportWebVitals();

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '../src/main-component/App/App';
import reportWebVitals from './reportWebVitals';
import GlobalAOSProvider from './GlobalAOSProvider/GlobalAOSProvider ';
import '../node_modules/react-modal-video/scss/modal-video.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './css/fontawesome.css';
import './css/themify-icons.css';
import './css/animate.min.css';
import './css/cursor.css';
import './css/style.css';
import './css/wallet.css';
import { ThirdwebProvider } from "@thirdweb-dev/react";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Ethereum } from '@thirdweb-dev/chains';

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <GlobalAOSProvider>
                <ThirdwebProvider activeChain={Ethereum} clientId="00000000000000000000000000000000">
                    <App />
                </ThirdwebProvider>
            </GlobalAOSProvider>
        </QueryClientProvider>
    </React.StrictMode>
);

reportWebVitals();
